import http from '@/utils/http';

// 评量工具使用次数
export const getScaleTotal = (params) => {
    return http({
        url: '/api/visualcss/v2/index/scale/all',
        method: 'get',
        params
    })
}
// IEP制定总数
export const getIEPTotal = (params) => {
    return http({
        url: '/api/visualcss/v2/index/iep/all',
        params
    })
}
// 教案总数
export const getPlanTotal = (params) => {
    return http({
        url: '/api/visualcss/v2/index/coursePlan/all',
        params
    })
}
//  热门评量工具
export const getScaleRank = (params) => {
    return http({
        url: '/api/visualcss/v2/index/scale',
        params
    })
}
// 资源文件上传数量
export const getFileNums = (params) => {
    return http({
        url: '/api/visualcss/v2/index/resourcesSupport',
        params
    })
}
// 资源文件上传数量
export const getResourceRank = (params) => {
    return http({
        url: '/api/visualcss/v2/index/courseResource',
        params
    })
}
